import { ACTIONS } from '@~/actions/chat-sound';
import chatSound from '@~/assets/chat-sound.mp3';

export default function defaultExport(state = null, { type }) {
  switch (type) {
    case ACTIONS.PLAY_CHAT_SOUND: {
      const audio = new Audio(chatSound);
      const promise = audio.play();

      if (promise !== undefined) {
        promise
          .then(() => {
            // Audio played successfully
          })
          .catch(() => {
            // Audio play failed
          });
      }
    }
    // eslint-disable-next-line no-fallthrough
    default:
      return state;
  }
}
